const AwardsList = ({
	title,
	data,
	classNames,
	sectionRef,
}) => {
	return (<section
		className={classNames.section}
		ref={sectionRef}
	>
		<h2 className={classNames.title}>{title}</h2>

		<div className={classNames.items}>
			{data.map((award, index) => (<div
				className={classNames.item}
				key={award.id ?? index}
			>
				<span className={classNames.site}>{award.site}</span>

				<div className={classNames.award}>
					<span>{award.award ?? ''}</span>
					<span>{award.times && award.times > 1 ? `x${award.times}` : ''}</span>
				</div>
			</div>))}
		</div>
	</section>)
}

export default AwardsList
